export default __webpack_public_path__ + "static/media/VIPS.4984b527.jpg";